/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.0
 */

import produce from 'immer';

import { TABLE_LOAD_SIZE } from '../../../constants';
import {
    BASKET_CLEAN_LIST,
    BASKET_GET_LIST_FAILED,
    BASKET_GET_LIST_START,
    BASKET_GET_LIST_SUCCESSFUL,
    BASKET_SET_INIT_LIST,
    BASKET_SHOW_LOADER,
} from './basketConstants';
import { BasketActionTypes, IBasketItem } from './basketTypes';

export interface IBasketState {
    initList: IBasketItem[];
    isLoading: boolean;
    list: IBasketItem[];
    from: number;
    size: number;
}

export const initBasketState: IBasketState = {
    initList: [],
    isLoading: false,
    list: [],
    from: 0,
    size: TABLE_LOAD_SIZE,
};

const basketReducer = (state = initBasketState, action: BasketActionTypes) =>
    produce(state, (draft) => {
        switch (action.type) {
            case BASKET_SHOW_LOADER:
                draft.isLoading = true;
                break;
            case BASKET_GET_LIST_START:
                break;
            case BASKET_GET_LIST_SUCCESSFUL:
                draft.isLoading = false;
                draft.list = action.payload.list;
                break;
            case BASKET_GET_LIST_FAILED:
                draft.isLoading = false;
                break;
            case BASKET_SET_INIT_LIST:
                draft.initList = action.payload.list;
                break;
            case BASKET_CLEAN_LIST:
                return initBasketState;
            default:
                break;
        }
    });

export default basketReducer;
